import { render, staticRenderFns } from "./BusinessCardReaders.vue?vue&type=template&id=6d2fb272"
import script from "./BusinessCardReaders.vue?vue&type=script&lang=js"
export * from "./BusinessCardReaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports